import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createUser, getUserById, updateUser } from "../../../services/user";
import * as yup from "yup";
import { useFormik } from "formik";
import Sidebar from "../../../components/Sidebar"; // Changed import
import { Container, Card, CardBody, CardTitle, Form, Row, Col, Input, Button, Label, FormFeedback } from "reactstrap";

const rank = [
  { id: 0, title: "Utilisateur" },
  { id: 1, title: "Créateur" },
  { id: 2, title: "Administrateur" }
];

const UserForm = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setIsEdit(true);
      getUserById(id)
        .then((response) => {
          setUser(response.data);
        })
        .catch((error) => console.error("Failed to fetch user:", error));
    }
  }, [id]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstname: user?.firstname || "",
      lastname: user?.lastname || "",
      email: user?.email || "",
      rank: user?.rank || 0,
      password: ""
    },
    validationSchema: yup.object({
      firstname: yup.string().required("Prénom obligatoire"),
      lastname: yup.string().required("Nom obligatoire"),
      email: yup.string().email("Email invalide").required("Email obligatoire"),
      password: yup.string().when("id", {
        is: !isEdit,
        then: yup.string().required("Mot de passe obligatoire").min(8)
      })
    }),
    onSubmit: async (values) => {
      console.log(values);
      try {
        if (isEdit) {
          const { password, ...updateData } = values;
          const dataToSend = password ? values : updateData;
          await updateUser(id, dataToSend);
        } else {
          await createUser(values);
        }
        navigate("/admin/users");
      } catch (error) {
        console.error("Failed to save user:", error);
      }
    }
  });

  return (
    <div className="admin-view d-flex h-100 w-100">
      <Sidebar />
      <div
        className="main-content w-100"
        style={{ height: "100vh", padding: 50 }}>
        <Card className="h-100">
          <CardBody>
            <CardTitle tag="h4">{isEdit ? "Modifier" : "Ajouter"} un utilisateur</CardTitle>

            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
              className="mt-4">
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <Label>Prénom</Label>
                    <Input
                      type="text"
                      name="firstname"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.firstname}
                      invalid={!!(validation.touched.firstname && validation.errors.firstname)}
                    />
                    {validation.touched.firstname && validation.errors.firstname && <FormFeedback type="invalid">{validation.errors.firstname}</FormFeedback>}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <Label>Nom</Label>
                    <Input
                      type="text"
                      name="lastname"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.lastname}
                      invalid={!!(validation.touched.lastname && validation.errors.lastname)}
                    />
                    {validation.touched.lastname && validation.errors.lastname && <FormFeedback type="invalid">{validation.errors.lastname}</FormFeedback>}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <Label>Email</Label>
                    <Input
                      type="email"
                      name="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email}
                      invalid={!!(validation.touched.email && validation.errors.email)}
                    />
                    {validation.touched.email && validation.errors.email && <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <Label>Rang</Label>
                    <Input
                      required={true}
                      type="select"
                      name="category"
                      onChange={(e) => {
                        validation.setFieldValue("rank", e.target.value);
                      }}
                      invalid={validation.errors.rank && validation.touched.rank}
                      onBlur={validation.handleBlur}>
                      {rank.length &&
                        rank.map((r) => (
                          <option
                            selected={validation.values.rank == r.id ? true : false}
                            value={r.id}>
                            {r.title}
                          </option>
                        ))}
                    </Input>
                    {validation.touched.email && validation.errors.email && <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>}
                  </div>
                </Col>
              </Row>
              {!isEdit && (
                <Row>
                  <Col md={12}>
                    <div className="mb-3">
                      <Label>Mot de passe</Label>
                      <Input
                        type="password"
                        name="password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password}
                        invalid={!!(validation.touched.password && validation.errors.password)}
                      />
                      {validation.touched.password && validation.errors.password && <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>}
                    </div>
                  </Col>
                </Row>
              )}
              <Button
                type="submit"
                color="primary">
                Enregistrer
              </Button>
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default UserForm;
